import React from 'react'
import MediaWithShimmer from './MediaWithShimmer'
import { useLanguage } from '../contexts/LanguageContext'
import { translations } from '../translations/translations'
import { Link } from 'react-router-dom'
import GoldenZigzag from './GoldenZigzag'
import order1 from '../imgs/order1.jpg'
import order2 from '../imgs/order2.jpg'
import order3 from '../imgs/order3.jpg'
import order4 from '../imgs/order4.jpg'
import order5 from '../imgs/order5.jpg'
import order6 from '../imgs/order6.jpg'
import order7 from '../imgs/order7.jpg'
import order8 from '../imgs/order8.jpg'
import order9 from '../imgs/order9.jpg'
import order10 from '../imgs/order10.jpg'
import order11 from '../imgs/order11.jpg'
import order14 from '../imgs/order14.jpg'
import order16 from '../imgs/order16.jpg'
import order19 from '../imgs/order19.jpg'
import order20 from '../imgs/order20.jpg'
import order21 from '../imgs/order21.jpg'
import order23 from '../imgs/order23.jpg'
import order24 from '../imgs/order24.jpg'
import red1 from '../imgs/red1.jpg'
import red2 from '../imgs/red2.jpg'
import red3 from '../imgs/red3.jpg'
import red4 from '../imgs/red4.jpg'
import red5 from '../imgs/red5.jpg'
import red6 from '../imgs/red6.jpg'
import red7 from '../imgs/red7.jpg'
import red9 from '../imgs/red9.jpg'
import coctail5 from '../imgs/coctail5.jpg'
import podium1 from '../imgs/podium1.jpg'
import podium3 from '../imgs/podium3.jpg'
import podium5 from '../imgs/podium5.jpg'
import podium6 from '../imgs/podium6.jpg'
import podium7 from '../imgs/podium7.jpg'
import podium8 from '../imgs/podium8.jpg'
import podium9 from '../imgs/podium9.jpg'
import podium10 from '../imgs/podium10.jpg'
import podium11 from '../imgs/podium11.jpg'
import podium13 from '../imgs/podium13.jpg'
import podium14 from '../imgs/podium14.jpg'
import podium15 from '../imgs/podium15.jpg'
import podium16 from '../imgs/podium16.jpg'
import podium17 from '../imgs/podium17.jpg'
import podium18 from '../imgs/podium18.jpg'
import podium19 from '../imgs/podium19.jpg'
import podium20 from '../imgs/podium20.jpg'
import podium21 from '../imgs/podium21.jpg'
import podium22 from '../imgs/podium22.jpg'
import podium23 from '../imgs/podium23.jpg'
import podium24 from '../imgs/podium24.jpg'
import podium25 from '../imgs/podium25.jpg'
import podium26 from '../imgs/podium26.jpg'
import podium28 from '../imgs/podium28.jpg'
import blackandwhite1 from '../imgs/blackandwhite1.jpg'
import blackandwhite2 from '../imgs/blackandwhite2.jpg'
import blackandwhite3 from '../imgs/blackandwhite3.jpg'
import blackandwhite4 from '../imgs/blackandwhite4.jpg'
import blackandwhite5 from '../imgs/blackandwhite5.jpg'
import blackandwhite6 from '../imgs/blackandwhite6.jpg'
import blackandwhite8 from '../imgs/blackandwhite8.jpg'

const FeaturedCollections = () => {
  const { language } = useLanguage()
  const t = translations.featuredCollections

  const collections1 = [
    {
      title: t.fashion[language],
      description: t.fashionDesc[language],
      image: "https://readdy.ai/api/search-image?query=Luxury%20fashion%20collection%20showcase%2C%20elegant%20black%20designer%20dress%20on%20marble%20background%2C%20premium%20fashion%20photography%2C%20minimalist%20styling%2C%20soft%20golden%20lighting%2C%20high-end%20commercial%20photography%2C%20sophisticated%20and%20timeless%20design&width=400&height=500&seq=fashion1&orientation=portrait"
    },
    {
      title: t.accessories[language],
      description: t.accessoriesDesc[language],
      image: "https://readdy.ai/api/search-image?query=Luxury%20accessories%20collection%2C%20elegant%20leather%20handbags%20and%20silk%20scarves%20on%20white%20marble%20surface%2C%20premium%20product%20photography%2C%20minimalist%20styling%2C%20soft%20golden%20lighting%2C%20high-end%20commercial%20photography%2C%20sophisticated%20luxury%20goods&width=400&height=500&seq=accessories1&orientation=portrait"
    },
    {
      title: t.fragrances[language],
      description: t.fragrancesDesc[language],
      image: "https://readdy.ai/api/search-image?query=Luxury%20perfume%20collection%2C%20elegant%20glass%20bottles%20with%20golden%20accents%20on%20white%20marble%20background%2C%20premium%20product%20photography%2C%20minimalist%20styling%2C%20soft%20golden%20lighting%2C%20high-end%20commercial%20photography%2C%20sophisticated%20fragrance%20display&width=400&height=500&seq=fragrances1&orientation=portrait"
    }
  ]

  const collections2 = [
    {
      title: t.jewelry[language],
      description: t.jewelryDesc[language],
      image: "https://readdy.ai/api/search-image?query=Luxury%20jewelry%20collection%2C%20elegant%20gold%20and%20diamond%20pieces%20on%20white%20marble%20background%2C%20premium%20jewelry%20photography%2C%20minimalist%20styling%2C%20soft%20golden%20lighting%2C%20high-end%20commercial%20photography%2C%20sophisticated%20luxury%20jewelry%20display&width=600&height=400&seq=jewelry1&orientation=landscape"
    },
    {
      title: t.limited[language],
      description: t.limitedDesc[language],
      image: "https://readdy.ai/api/search-image?query=Luxury%20limited%20edition%20collection%2C%20exclusive%20designer%20pieces%20with%20golden%20details%20on%20white%20marble%20background%2C%20premium%20fashion%20photography%2C%20minimalist%20styling%2C%20soft%20golden%20lighting%2C%20high-end%20commercial%20photography%2C%20sophisticated%20exclusive%20items&width=600&height=400&seq=limited1&orientation=landscape",
      badge: t.badgeLimited[language]
    }
  ]

  const collections3 = [
    {
      title: t.spring[language],
      description: t.springDesc[language],
      image: "https://readdy.ai/api/search-image?query=Luxury%20spring%20fashion%20collection%2C%20elegant%20pastel%20colored%20designer%20dresses%20with%20floral%20details%20on%20white%20marble%20background%2C%20premium%20fashion%20photography%2C%20minimalist%20styling%2C%20soft%20golden%20lighting%2C%20high-end%20commercial%20photography%2C%20sophisticated%20spring%20fashion&width=400&height=500&seq=spring1&orientation=portrait",
      badge: t.badgeNew[language]
    },
    {
      title: t.resort[language],
      description: t.resortDesc[language],
      image: "https://readdy.ai/api/search-image?query=Luxury%20resort%20fashion%20collection%2C%20elegant%20summer%20designer%20clothing%20with%20golden%20accents%20on%20white%20marble%20background%2C%20premium%20fashion%20photography%2C%20minimalist%20styling%2C%20soft%20golden%20lighting%2C%20high-end%20commercial%20photography%2C%20sophisticated%20resort%20wear&width=400&height=500&seq=resort1&orientation=portrait"
    },
    {
      title: t.bridal[language],
      description: t.bridalDesc[language],
      image: "https://readdy.ai/api/search-image?query=Luxury%20bridal%20fashion%20collection%2C%20elegant%20white%20wedding%20dresses%20with%20golden%20details%20on%20white%20marble%20background%2C%20premium%20fashion%20photography%2C%20minimalist%20styling%2C%20soft%20golden%20lighting%2C%20high-end%20commercial%20photography%2C%20sophisticated%20bridal%20wear&width=400&height=500&seq=bridal1&orientation=portrait"
    }
  ]

  const redCollection = [
    red2,
    red3,
    red4,
    red5,
    red7,
    red9
  ]
  const luxuryHandmakerCollection = [
    podium1,
    podium3,
    podium5,
    podium6,
    podium7,
    podium8,
    podium9,
    podium10,
    podium11,
    podium13,
    podium14,
    podium15,
    podium16,
    podium17,
    podium18,
    podium22,
    podium19,
    podium21,
    podium24,
    podium20,
    podium25,
    podium26,
    podium23,
    podium28,
    coctail5
  ]
  const blackAndWhiteCollection = [
    blackandwhite1,
    blackandwhite2,
    blackandwhite3,
    blackandwhite5,
    blackandwhite6,
    blackandwhite8
  ]

  const madeToOrderImages = [
    order1,
    order2,
    order3,
    order4,
    order5,
    order6,
    order7,
    order8,
    order9,
    order10,
    order11,
    order14,
    order16,
    order19,
    order20,
    order21,
    order23,
    order24
  ]

  return (
    <section className="px-6 lg:px-12">
      <div className="max-w-7xl mx-auto">
        <div className="" id="red-collection">
          <h4 className="text-3xl md:text-4xl font-light mb-5 text-center playfair">
            {t.redCollectionTitle[language]}
          </h4>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {redCollection.map((image, index) => (
              <Link to="/shop" key={index} className="group cursor-pointer block">
                <div className="relative overflow-hidden mb-4">
                  <MediaWithShimmer
                    alt={`Red collection look ${index + 1} ALRICHE`}
                    className="w-full h-[620px] md:h-[580px] object-cover object-top transition-transform duration-700 group-hover:scale-105"
                    src={image}
                  />
                  <div className="absolute inset-0 bg-black/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                </div>
              </Link>
            ))}
          </div>
        </div>
        <GoldenZigzag />
        <div className="" id="luxury-handmaker">
          <h4 className="text-3xl md:text-4xl font-light mb-5 text-center playfair">
            {t.luxuryHandmakerTitle[language]}
          </h4>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {luxuryHandmakerCollection.map((image, index) => (
              <Link to="/shop" key={index} className="group cursor-pointer block">
                <div className="relative overflow-hidden mb-4">
                  <MediaWithShimmer
                    alt={`Luxury Collection Handmaker look ${index + 1} ALRICHE`}
                    className="w-full h-[620px] md:h-[580px] object-cover object-top transition-transform duration-700 group-hover:scale-105"
                    src={image}
                  />
                  <div className="absolute inset-0 bg-black/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                </div>
              </Link>
            ))}
          </div>
        </div>
        <GoldenZigzag />
        <div className="" id="black-and-white-collection">
          <h4 className="text-3xl md:text-4xl font-light mb-5 text-center playfair">
            {t.blackAndWhiteTitle[language]}
          </h4>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {blackAndWhiteCollection.map((image, index) => (
              <Link to="/shop" key={index} className="group cursor-pointer block">
                <div className="relative overflow-hidden mb-4">
                  <MediaWithShimmer
                    alt={`Black and White Collection look ${index + 1} ALRICHE`}
                    className="w-full h-[620px] md:h-[580px] object-cover object-top transition-transform duration-700 group-hover:scale-105"
                    src={image}
                  />
                  <div className="absolute inset-0 bg-black/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                </div>
              </Link>
            ))}
          </div>
        </div>
        <GoldenZigzag />
        <div className="mb-5 text-center" id="collection-for-sale">
          <h4 className="text-2xl md:text-3xl font-light tracking-[0.18em] uppercase playfair">
            {t.collectionForSaleTitle[language]}
          </h4>
        </div>
        <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {madeToOrderImages.map((src, index) => (
            <Link to="/shop" key={index} className="group cursor-pointer block">
              <div className="relative overflow-hidden rounded-3xl border border-[#CEA15F]/40 shadow-[0_0_30px_rgba(206,161,95,0.2)]">
                <MediaWithShimmer
                  src={src}
                  alt={language === 'ru' ? `Под заказ ${index + 1}` : `Made to order ${index + 1}`}
                  className="w-full h-[620px] md:h-[580px] object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-black/15 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  )
}

export default FeaturedCollections

